import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import PageHeader from "@/components/settings/PageHeader";
import { BalanceCard } from "@/components/settings/BalanceCard";
import SettingsMenuItem from "@/components/settings/SettingsMenuItem";
import IconImage from "@/components/settings/IconImage";
import { PaymentBottomSheet } from "@/components/settings/bottom-sheets/Payment";
import { AddNewCardBottomSheet } from "@/components/settings/bottom-sheets/AddNewCard";
import { TransactionDetailBottomSheet } from "@/components/settings/bottom-sheets/TransactionDetail";
import { TTransaction } from "@wtf/shared";
import { assetPath } from "@/utils/assetPath";

const transactions = [
  {
    id: "1",
    amount: 2000,
    type: "withdraw",
    date: "Feb 6, 2025",
  },
  {
    id: "2",
    amount: 15,
    type: "subscription",
    date: "Feb 6, 2025",
  },
  {
    id: "3",
    amount: 15,
    type: "subscription",
    date: "Feb 6, 2025",
  },
  {
    id: "4",
    amount: 15,
    type: "subscription",
    date: "Feb 6, 2025",
  },
  {
    id: "5",
    amount: 1000,
    type: "withdraw",
    date: "Feb 6, 2025",
  },
  {
    id: "6",
    amount: 15,
    type: "withdraw",
    date: "Feb 6, 2025",
  },
  {
    id: "7",
    amount: 15,
    type: "withdraw",
    date: "Feb 6, 2025",
  },
  {
    id: "8",
    amount: 15,
    type: "withdraw",
    date: "Feb 6, 2025",
  },
];

export const Route = createFileRoute("/settings/wallet")({
  component: RouteComponent,
});

function RouteComponent() {
  return <WalletPage />;
}

const WalletPage = () => {
  const [openTransactionDetail, setOpenTransactionDetail] = useState(false);
  const [selectedTransaction] = useState<TTransaction | null>(null);
  const [openPayment, setOpenPayment] = useState(false);
  const [openAddNewCard, setOpenAddNewCard] = useState(false);

  const handleAddNewCardClick = () => {
    setOpenPayment(false);
    setOpenAddNewCard(true);
  };
  return (
    <div className="h-[100dvh] max-w-md mx-auto overflow-y-auto bg-white px-2 pb-20 relative">
      <PageHeader title="Wallet" />
      <div className="w-full flex flex-col gap-2">
        <BalanceCard />
        <SettingsMenuItem
          title="Payment"
          description="Payment information for withdraw funds"
          icon={<IconImage name="credit-card" alt="credit-card" />}
          onClick={() => setOpenPayment(true)}
        />
        <hr className="w-full border-black-6 my-2" />
        <h2 className="font-semibold mb-1">Transactions</h2>
        <div className="flex flex-col gap-3">
          {transactions.map((transaction) => (
            <div
              key={transaction.id}
              className="flex  gap-3 items-center justify-between"
            // onClick={() => handleTransactionClick("transaction")}
            >
              <div className="flex gap-3 items-center">
                <div className="w-12 h-12 rounded-full border border-black-6 flex items-center justify-center">
                  <img
                    src={transaction.type === "withdraw" ? assetPath("icons/settings/arrow-up-right.svg") : assetPath("icons/settings/star.svg")}
                    alt="withdraw"
                  />
                </div>
                <div className="flex flex-col">
                  <h2 className=" text-14 font-semibold">
                    {transaction.type === "withdraw"
                      ? "Withdrew funds"
                      : "New subscribe"}
                  </h2>
                  <p className="text-black-48 text-13">{transaction.date}</p>
                </div>
              </div>

              <p
                className={`text-14 font-semibold ${transaction.type === "withdraw" ? "text-red" : "text-green"
                  }`}
              >
                {transaction.type === "withdraw" ? "-" : "+"} $
                {transaction.amount}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Withdraw Funds Button */}
      <div className="fixed max-w-md mx-auto bottom-0 left-0 right-0 px-2 pt-13 pb-4 bg-gradient-to-b from-transparent to-white">
        <button
          className="w-full py-4 rounded-[14px] bg-black text-white font-medium text-center"
          onClick={() => { }}
        >
          Withdraw funds
        </button>
      </div>

      <section className="fixed">
        <PaymentBottomSheet
          open={openPayment}
          onClose={() => setOpenPayment(false)}
          onAddNewCard={handleAddNewCardClick}
        />
        <AddNewCardBottomSheet
          open={openAddNewCard}
          onClose={() => setOpenAddNewCard(false)}
        />
        <TransactionDetailBottomSheet
          open={openTransactionDetail}
          onClose={() => setOpenTransactionDetail(false)}
          transaction={selectedTransaction}
        />
      </section>
    </div>
  );
};
